import React from 'react'
import moment from 'moment'


const ProPublicaFooter = (props) => {
  var now = moment().format("YYYY-MM-DD")
  // @TODO fix hardcoded values
  var primaryDate = moment([2018, 2, 20]);
  var generalDate = moment([2018, 11, 6]);
  var daysToPrimary = primaryDate.diff(now, 'days');
  var monthsToGeneral = generalDate.diff(now, 'months');

  daysToPrimary = 0;

  if (daysToPrimary > 0) {
    var daysToPrimaryLabel = <span>in {daysToPrimary} days</span>
  } else if (daysToPrimary === 0) {
    var daysToPrimaryLabel = <strong className="today">today</strong>
  } else if (daysToPrimary < 0) {
    var daysToPrimaryLabel = <span>{Math.abs(daysToPrimary)} days ago</span>
  }

  if (daysToPrimary > 1) {
    var daysToPrimaryLabel = <span>in {daysToPrimary} days</span>
  } else if (daysToPrimary === 1) {
    var daysToPrimaryLabel = <span>in {daysToPrimary} day</span>
  } else if (daysToPrimary === 0) {
    var daysToPrimaryLabel = <strong className="today">today</strong>
  } else if (daysToPrimary < 0) {
    var daysToPrimaryLabel = <span>{Math.abs(daysToPrimary)} days ago</span>
  }

  return (<div>
    <p className="last-updated">
      Last updated: {props.data.govPrimaryJson.raised_date}
    </p>

    <p className="notes">
      Last updated: {props.data.govPrimaryJson.raised_date}
    </p>


    <p className="notes">
      Notes:

      Donations updated daily from Jan. 1, 2015.

      Spending data is from Jan. 1, 2015 through {props.data.govPrimaryJson.spending_date}, the most recent reporting date.

      Self-funding calculations do not include funds carried over from prior to 2015.

      Source: Illinois State Board of Elections
    </p>

  </div>)
}

export default ProPublicaFooter



// WEBPACK FOOTER //
// ./src/components/ProPublicaFooter/index.js